import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title", "description", "imageUrl", "collectionSlug", "cards"];
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { EcosystemListingStub } from 'trellis-ecosystem';
import { CollectionCard } from './CollectionCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CollectionSection(_ref) {
  let {
      title,
      description,
      imageUrl,
      collectionSlug,
      cards
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "1000",
    children: /*#__PURE__*/_jsxs(Grid, Object.assign({}, restProps, {
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: {
          xs: 12,
          lg: 6
        },
        children: /*#__PURE__*/_jsx(CollectionCard, {
          name: title,
          description: description,
          imageSrc: imageUrl !== null && imageUrl !== void 0 ? imageUrl : '',
          use: "on-dark",
          slug: collectionSlug
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        paddingBlockEnd: "400",
        size: {
          xs: 12,
          lg: 0
        }
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          xs: 12,
          lg: 6
        },
        children: /*#__PURE__*/_jsx(Flex, {
          blockSize: "100%",
          alignItems: "stretch",
          children: /*#__PURE__*/_jsx(Grid, {
            children: cards.map((item, index) => {
              var _item$listingName, _item$iconUrl, _item$slug, _item$providerName;
              return /*#__PURE__*/_jsx(GridItem, {
                padding: "300",
                size: {
                  xs: 6,
                  md: 4,
                  lg: 6
                },
                children: /*#__PURE__*/_jsx(EcosystemListingStub, {
                  name: (_item$listingName = item.listingName) !== null && _item$listingName !== void 0 ? _item$listingName : '',
                  imageSrc: (_item$iconUrl = item.iconUrl) !== null && _item$iconUrl !== void 0 ? _item$iconUrl : '',
                  productType: "APP",
                  listingHref: (_item$slug = item.slug) !== null && _item$slug !== void 0 ? _item$slug : '',
                  providerName: (_item$providerName = item.providerName) !== null && _item$providerName !== void 0 ? _item$providerName : ''
                })
              }, `ecosystem-listing-stub-${index}`);
            })
          })
        })
      })]
    }))
  });
}